import {
  Column,
  FluidImage,
  GridContainer,
  H2,
  Link,
  Row,
  StandardTile,
  StandardTileImage,
  TabContent,
  TabHeader,
  Tabs,
  TabsContents,
  TabsHeaders,
  Typography
} from '@vp/swan'
import React, { useRef } from 'react'
import { IMAGE_ALIGN } from './constants'
import { useAppContext } from '../../state/AppContext'
import { trackNavigationClicks, trackTabSelected } from '../../utils/tracking/tracking'

// This is PM ask to replace " and " with " & "
const getHeaderText = (text: string = '') => {
  return text.replace(' and ', ' & ')
}

const DesignTemplate = () => {
  const { designTemplateData, dictionaryEntries } = useAppContext()
  const data = designTemplateData?.designTemplates
  const ref = useRef<HTMLDivElement>(null)
  const { merchandisingCategoryId } = useAppContext()
  const [selectedTabId, setSelectedTabId] = React.useState<string | null>('1')

  if (!data || !data.length) {
    return <></>
  }

  if (data && data.length > 0 && data[0]) {
    const mostPopularCTA = dictionaryEntries['mostPopularCTA'] ?? ''
    data[0].tabHeader = mostPopularCTA as string
  }
  const title = dictionaryEntries['designTemplateHeader']
  const description = dictionaryEntries['designTemplateDescription']
  const cta = dictionaryEntries['designTemplateCTA']
  const getBrowseAllLink = (categoryKey?: string) => {
    if (categoryKey) {
      return `${designTemplateData.browseAllUrl}?categories=${categoryKey}`
    }
    return `${designTemplateData.browseAllUrl}`
  }

  const handleTabChange = (tabId: string | null) => {
    if (tabId) {
      setSelectedTabId(tabId)
      sessionStorage.setItem('designTemplateTabId', tabId)
    }
  }

  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <H2 fontSize="x2large" marginBottom="5">
            {title}
          </H2>
        </Column>
      </Row>
      <Row marginBottom="4">
        <Column span={12}>
          <Typography>{description}</Typography>
        </Column>
      </Row>

      <Row>
        <Column span={12}>
          <Tabs
            selectedTabId={selectedTabId}
            onRequestTabChange={(requestedTabId) => {
              trackTabSelected({
                categoryId: merchandisingCategoryId,
                pageZone: 'designTemplate',
                tabIndex: requestedTabId
              })
              handleTabChange(requestedTabId)
            }}
          >
            <TabsHeaders ref={ref}>
              {data.map((item: any, tabIndex: number) => (
                <TabHeader tabId={`${tabIndex + 1}`} key={`${tabIndex + 1}`}>
                  {getHeaderText(item.tabHeader)}
                </TabHeader>
              ))}
            </TabsHeaders>
            <TabsContents>
              {data.map((tab: any, tabIndex: number) => {
                const currentTabId = `${tabIndex + 1}`
                const isActiveTab = selectedTabId === currentTabId

                return (
                  <TabContent key={tab.tabHeader} tabId={currentTabId}>
                    {isActiveTab && (
                      <>
                        <GridContainer>
                          <Row>
                            {tab.templates.map((template: any, templateIndex: number) => {
                              return (
                                <Column key={template.designId} span={3} spanXs={6}>
                                  <StandardTile
                                    skin="product"
                                    onClick={() => {
                                      trackNavigationClicks({
                                        categoryId: merchandisingCategoryId,
                                        pageZone: 'designTemplate',
                                        destinationUrl: template.urlToQuickView,
                                        tabIndex: tabIndex + 1,
                                        templateIndex: templateIndex + 1,
                                        designId: template.designId
                                      })
                                    }}
                                  >
                                    <StandardTileImage m={0}>
                                      <FluidImage
                                        src={template.image}
                                        style={{
                                          verticalAlign: IMAGE_ALIGN
                                        }}
                                        loading="lazy"
                                      />
                                      <Link
                                        href={template.urlToQuickView}
                                        covering
                                        style={{
                                          verticalAlign: IMAGE_ALIGN
                                        }}
                                      />
                                    </StandardTileImage>
                                  </StandardTile>
                                </Column>
                              )
                            })}
                          </Row>
                        </GridContainer>
                        <Row>
                          <Column span={12}>
                            <Link
                              id="see-all-cta"
                              skin="cta"
                              href={getBrowseAllLink(tab.categoryKey)}
                              onClick={() => {
                                trackNavigationClicks({
                                  categoryId: merchandisingCategoryId,
                                  pageZone: 'designTemplate',
                                  destinationUrl: getBrowseAllLink(tab.categoryKey),
                                  tabIndex: tabIndex + 1,
                                  isDesignTemplateCTA: true
                                })
                              }}
                            >
                              {cta}
                            </Link>
                          </Column>
                        </Row>
                      </>
                    )}
                  </TabContent>
                )
              })}
            </TabsContents>
          </Tabs>
        </Column>
      </Row>
    </GridContainer>
  )
}

export default DesignTemplate
